import { createAction, props } from '@ngrx/store';
import { RealEstateObject } from '@immosky/types';

export enum SimilarResultsActions {
  Set = '[Results] Set Similar Real Estate Objects',
}

export const setSimilarRealEstateObjects = createAction(
  SimilarResultsActions.Set,
  props<{ objects: RealEstateObject[] }>()
);
